// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "em-date-input{position:relative;display:block}.em-date-input-container{position:relative}.em-date-input-icon{position:absolute;right:0;top:0;height:100%;padding:8px;box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
